import {
  createHashRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';
import React from 'react';
import App from '../App';
import CreateAccount from '../pages/CreateAccount';

const router = createHashRouter(
  createRoutesFromElements(
    <Route>
      <Route path="*" Component={App} />
      <Route path="/session/:sessionId" Component={App} />
      <Route path="/create-accounts" Component={CreateAccount} />
    </Route>
  )
);

const Router = () => {
  return <RouterProvider router={router} />;
};

export default Router;
